import { FC } from 'react'
import { DetailField } from './DetailField.component'
import { useTranslation } from 'react-i18next'

interface Props {
  /** Field label */
  label?: string
  /** Boolean value - component auto-hides when null or undefined */
  value?: boolean | null
}

/**
 * Boolean field that renders "Yes" or "No" using translated labels.
 * Auto-hides when value is null or undefined.
 * @example
 * <DetailBooleanField label="Fixtures" value={true} />   // Shows "Yes"
 * <DetailBooleanField label="Compass" value={false} />    // Shows "No"
 * <DetailBooleanField label="Garden" value={null} />      // Hidden
 */
export const DetailBooleanField: FC<Props> = ({ label, value }) => {
  const { t } = useTranslation(['common'])

  if (value === undefined || value === null) return null

  return <DetailField label={label} value={value ? t('common:Yes') : t('common:No')} />
}
